angular.module('profile.routes', [
  'ui.router'
]).config(function config($stateProvider) {
  $stateProvider.state('profile', {
      url: '/profile',
      controller: 'Profile',
      templateUrl: 'components/profiles/profile.html',
      params: {
        requiresLogin: true
      }
    }).state('profileProposal', {
      url: '/profile/proposal/:proposalId',
      controller: 'Profile',
      templateUrl: 'components/profiles/profile.html',
      params: {
        requiresLogin: true
      }
    }).state('edit-profile', {
      url: '/edit-profile',
      controller: 'Profile',
      templateUrl: 'components/profiles/edit-profile.html',
      params: {
        requiresLogin: true
      }
    });
})
